//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import optionalQuestionsCopy from "../../../../data/registrationOptionalQuestions.json"
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "PageOptionalQuestions",
  data() {
    return{
      copy: optionalQuestionsCopy.registrationOptionalQuestions.default,
      getQuestionsEndpoint: '/api/account/getoptionalquestions',
      setQuestionsEndpoint: '/api/account/saveoptionalquestions',
      optionalQuestionsData: {
      },
      optionalQuestionsCount: '',
      formData: null
    }
  },
  computed: {
		...mapGetters(["isError", "isDisabled", "isLoading"])
  },
  methods: {
		...mapMutations(["setRegistration","setOptionalQuestions", "setDisabled", "setLoading"]),
		...mapActions(["getData","submitOptionalQuestions"]),
    processOptionalQuestions(data) {
      data.preventDefault()
      // console.log(data)
      // split form element values by | to prevent writing complicated dynamic computed getters.
      // object -> array -> map -> split -> loop -> create object -> push to array
      let formData = []
      formData.push({
        "name": data.target.name
      })
      Object.values(this.formData).map(x => x.split('|')).forEach(element => {
          formData.push({
            "field" : element[0],
            "choice" : element[1]
          })
      });
      // console.log(formData)
      const endpoint = this.setQuestionsEndpoint
      // formData.endpoint = this.setQuestionsEndpoint
      // console.log(formData)
      // do stuff
      this.setDisabled(true)
      this.setLoading(true)
      this.submitOptionalQuestions({formData, endpoint})
    },
    skipOptionalQuestions() {
      this.setOptionalQuestions(false)
    },
    updateQuestions(val, index) {
      this.formData[index] = val
    }
  },
  created() {
    this.setLoading(true)
    fetch(this.getQuestionsEndpoint, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
    }).then((response) => response.json())
      .then((data) => {
        this.optionalQuestionsData = Object.assign({},data)
        this.formData = new Array(data.questions.length)
        for (let i = 0; i < this.optionalQuestionsData.questions.length; i++) {
          const question = this.optionalQuestionsData.questions[i];
          // console.log(question)
          question.choices.forEach(choice => {
            if(choice.selected) {
              this.formData[i] = `${question.field}|${choice.value}`
            }
        });
        setTimeout(() => {
          this.setLoading(false)
        }, 1000);
      }
      });
  },
  // watch: {
  //   optionalQuestionsData(){
      
  //   },
  // }
};
